import { ReportAuctionsProps } from "@entities/history/ui/report-auctions/types";
import { CheckIcon } from "@shared/ui/Icon/ui/history/check-icon";
import { WarnIcon } from "@shared/ui/Icon/ui/history/warn-icon";
import classes from "./report-auctions.module.scss";

export const ReportAuctions = ({ salvageCarAuctionRecords }: ReportAuctionsProps) => {
    const hasRecords =
        Array.isArray(salvageCarAuctionRecords) && salvageCarAuctionRecords.length > 0;

    return (
        <div className={classes.auctions}>
            <div className={classes.auctions__note}>
                <WarnIcon className={classes["auctions__note--icon"]} />
                Проверили в базе крупнейшего онлайн-аукциона битых автомобилей с тотальным ущербом.
            </div>
            <div className={classes.auctions__result}>
                <CheckIcon className={classes["auctions__result--icon"]} />
                {hasRecords
                    ? "Автомобиль участвовал в аукционе"
                    : "Мы не нашли данных о зарубежных аукционах."}
            </div>
        </div>
    );
};